module["exports"] = [
  "#{city_root}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/vi/address/city.js
// module id = 1640
// module chunks = 1